// extracted by mini-css-extract-plugin
export default {"state":"load-error_state__sxtBe","title":"load-error_title__WQFnm","text":"load-error_text__Yq+4w","actions":"load-error_actions__s03wR"};